<a
  class="key"
  [class.active]="isSelected"
  (click)="handleKeyClicked(character)"
>
  <span>{{ character }}</span>
  <span *ngIf="characters">{{ characters }}</span>
</a>
